
import Vue from 'vue'
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'
import { navList } from '@/util/navUtilities'

export default Vue.extend({
  name: 'JcdcNavRouterLinkRouter',
  components: {
    JcdcBtn,
  },
  props: {
    item: { type: Object as () => navList, required: true },
    menuLevel: { type: Number, default: 0 },
    routeTest: { type: Array as () => string[], default: (): [] => [] }, // For Testing
    isActive: { type: Boolean, default: false },
  },
  data() {
    return {
      storybook: process.env.NODE_ENV == 'storybook',
    }
  },
})
